import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import {
    Box,
    IconButton,
    Typography,
} from '@mui/material';
import {
    AddCircleOutline,
    Cancel,
    Check,
    Undo,
} from '@mui/icons-material';

import PermissionGuard, { HasPermissions } from '../../contexts/PermissionContext';
import SecondaryButton from '../buttons/SecondaryButton';
import SettingsTextField from '../textfield/SettingsTextField';
import SettingsCheckBox from '../checkbox/SettingsCheckBox';
import SettingsChipTextField from '../textfield/SettingsChipTextField';


function AvidPanelSettings({ schema={}, settings={}, setSettings = () => {} }) {

    const [avidPanelSettings, setAvidPanelSettings] = useState(settings);
    useEffect(() => {
        setAvidPanelSettings(settings)
    }, [settings])

    function handleChange(field, value) {
        const updatedSettings = _.cloneDeep(avidPanelSettings);
        updatedSettings[field] = value;
        updateSettings(updatedSettings);
    }

    function handleDiscard() {
        updateSettings(settings);
    }

    function updateSettings(newSettings) {
        setAvidPanelSettings(newSettings);
        console.log(newSettings);
        setSettings(newSettings);
    }

    return (
        <Box
            display="flex"
            border={'1px solid rgba(139, 142, 146, 1)'}
            borderRadius={4}
            position="relative"
        >
            <Box
                m={2}
                display="flex"
                flexDirection="column"
                gap={2}
                width='100%'
            >
                <Typography
                    variant="h6"
                >
                    Avid Panel Integration
                </Typography>
                <Box
                    display="flex"
                    flexDirection="column"
                    p={1}
                    sx={{
                        border: '1px solid rgba(92, 92, 92, 1)',
                        borderRadius: 3,
                        '&:hover': {
                            border: HasPermissions(schema?.permissions?.write) && '1px solid rgba(139, 142, 146, 1)'
                        },
                        transition: 'border 0.15s ease-out',
                }}>
          
                    <SettingsChipTextField
                        description={`List of Avid Panel fields to show in the Explore Page. Expects formatting "<your_field_name>". Example: "Name"`}
                        disabled={!HasPermissions(schema?.permissions?.write)}
                        label='Explore Page Fields'
                        onChange={(values) => handleChange('explore_page_fields', {...avidPanelSettings?.explore_page_fields, fields: values})}
                        original={settings?.explore_page_fields?.fields ?? []}
                        values={avidPanelSettings?.explore_page_fields?.fields ?? []}
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default AvidPanelSettings;